import React, { memo } from 'react';

import logoUrl from '../assets/lynear-wealth-logo.svg';

/**
 * The LIV web app's loader (web/src/components/Loader), so a wait in the Console looks like a wait
 * in LIV: the Lynear logo cut into four quadrants that spin, drift apart and snap back together.
 *
 * Same markup, sizes and animation as LIV's. The one difference is the logo: LIV imports the SVG as
 * a React component through webpack's SVGR, and this bundle inlines it as a data URL instead, so the
 * signed bundle stays one self-contained file. Styles are in styles/console.css (.lynear-loader*).
 */
const SIZE_MAP = {
    small: 22,
    large: 40
};

const resolveSize = (size) => {
    if (typeof size === 'number' && Number.isFinite(size)) return size;
    if (size === 'large') return SIZE_MAP.large;
    if (size === 'small') return SIZE_MAP.small;
    return 36;
};

const QuadrantPiece = memo(({ quadrantClass }) => (
    <div className={`lynear-loader__quadrant ${quadrantClass}`}>
        <img src={logoUrl} alt="" aria-hidden="true" className="lynear-loader__logo" draggable={false} />
    </div>
));

QuadrantPiece.displayName = 'QuadrantPiece';

const Loader = ({ size = 48, className = '', style = {} }) => (
    <div
        className={['lynear-loader', className].filter(Boolean).join(' ')}
        style={{ ...style, '--lynear-loader-size': `${resolveSize(size)}px` }}
        role="status"
        aria-label="Loading"
    >
        <div className="lynear-loader__spin">
            <QuadrantPiece quadrantClass="lynear-loader__quadrant--tl" />
            <QuadrantPiece quadrantClass="lynear-loader__quadrant--tr" />
            <QuadrantPiece quadrantClass="lynear-loader__quadrant--br" />
            <QuadrantPiece quadrantClass="lynear-loader__quadrant--bl" />
        </div>
    </div>
);

/** Full-height centred loader - LIV's PageLoader. */
export const PageLoader = ({ size = 'large', className = '', children }) => (
    <div className={['lgim-spinner', className].filter(Boolean).join(' ')}>
        <Loader size={size} />
        {children}
    </div>
);

/** Loader centred in a block of a given minimum height - LIV's CenteredLoader. */
export const CenteredLoader = ({ size = 'large', minHeight = 200, className = '' }) => (
    <div className={['lynear-centered-loader', className].filter(Boolean).join(' ')} style={{ minHeight }}>
        <Loader size={size} />
    </div>
);

export default memo(Loader);
